import { useCallback, useMemo, useState } from 'react';

/**
 * Hook UI para OrderNoteMessageMC
 * Solo maneja el estado de productos a mostrar y el handler para ver todos.
 * No contiene lógica de negocio ni de datos.
 */
export default function useOrderNoteMessageUI(order) {
  const [productsToShow, setProductsToShow] = useState(() =>
    order?.products?.length > 3 ? 3 : order?.products?.length
  );
  const [showMore, setShowMore] = useState(order?.products?.length > 3);

  const handleShowAll = useCallback(() => {
    setProductsToShow(order?.products?.length);
    setShowMore(false);
  }, [order?.products?.length]);

  return useMemo(
    () => ({ productsToShow, showMore, handleShowAll }),
    [productsToShow, showMore, handleShowAll]
  );
}
